<template>
    <div class="method-statement-form row">
        <div class="loaders--container" v-if="saving">
            <div class="loaders--standard"></div>
        </div>

        <div class="col-12 col-md-6">
            <div class="form-group">
                <label class="form-label" for="method">Method</label>
                <input type="text" class="form-control" id="method" placeholder="Enter Method" v-model="methodStatementData.title">
            </div>

            <div class="form-group">
                <label class="form-label" for="stages">Stages</label>
                <textarea type="text" class="form-control" id="stages" placeholder="Enter Stages" v-model="methodStatementData.stages" rows="8"></textarea>
            </div>
        </div>

        <div class="col-12 text-right">
            <button @click="save()" class="btn btn-primary">Save</button>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: "MethodStatementCreateEditPage",

        components: {
            draggable
        },

        props: {
            method: {
                type: String,
                default: 'post'
            },
            submitUrl: {
                type: String,
                required: true
            },
            methodStatement: {
                type: Object,
                default: () => { return {} }
            },

            backUrl: {
                type: String,
                required: true
            },
        },

        data(){
            return {
                methodStatementData: {
                    title: '',
                    stages: ''
                },

                saving: false,

                errors: []
            }
        },

        mounted() {
            window.addEventListener('LAYOUT:primary_button', this.save);
            window.addEventListener('LAYOUT:cancel_button', this.cancel);

            this.methodStatementData = {...this.methodStatementData, ...this.methodStatement};
        },

        methods: {
            save: function(){
                this.errors = [];

                if (this.saving){
					return false;
                }

				this.saving = true;

                axios({
                    'method': this.method,
                    'url': this.submitUrl,
                    'data': this.methodStatementData
                }).then((response) => {
                    this.saving = false;
                    window.location.href = response.data.url;
                }).catch((error) => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }

                    this.saving = false;
                });
            },

            cancel: function(){
                window.location.href = this.backUrl;
            },
        }
    }
</script>
